import React, { useCallback, useEffect, memo, useMemo } from "react";
import { API } from "../../api";
import { useInfiniteQuery } from "@tanstack/react-query";
import moment from "moment";
import { getAccessToken } from "../../api/auth";
import CouponReservationItem from "../coupon/CouponReservationItem";
import CouponSelectSheet from "../coupon/CouponSelectSheet";

type CouponPage = {
  results: any[];
  next?: string | null;
};

const CouponReservationSelectModal = memo((props: any) => {
  const [holidays, setHolidays] = React.useState([]);

  const today = moment(moment().format("YYYY-MM-DD"));
  const boundType = "reservation";


  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const accessToken = getAccessToken();

  useEffect(() => {
    const this_year = today.format("YYYY");
    API.get(`/package/holiday/${this_year}/`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => response.data)
      .then((_data) => {
        console.log("holiday", _data);
        setHolidays(_data.result);
      })
      .catch((error) => console.log(error));
  }, [accessToken]);

  const fetchData = useCallback(
    async ({ pageParam = 1 }) => {
      const response = await API.get(`/coupon/user/?page=${pageParam}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = response.data;
      //   console.log("orderdata", data);
      return { ...data, results: data.results };
    },
    [accessToken]
  );

  const { data, isSuccess, isLoading, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: ["userCouponSelectionList"],
    queryFn: async ({ pageParam = 1 }) => {
      const data = await fetchData({ pageParam });
      return data as CouponPage;
    },
    getNextPageParam: (lastPage: CouponPage) => {
      if (lastPage && lastPage.next) {
        const match = String(lastPage.next).match(/page=(\d+)/);
        if (match) {
          return Number(match[1]);
        }
      }
      return undefined;
    },
    initialPageParam: 1,
  });

  const filteredCoupons = useMemo(() => {
    if (!data || !isSuccess) return [];
    return data.pages.flatMap((page: CouponPage) =>
      page.results.filter((coupons: any) => coupons.coupon.bound_type === "reservation" && coupons.state === "사용안함")
    );
  }, [data, isSuccess]);

  const selectedCouponForSeat = useMemo(() => {
    return props.selectCoupon.find((coupon: any) => (
      coupon.product_id === props.seats.product_id && coupon.spot_id === props.seats.spot_id
    ));
  }, [props.selectCoupon, props.seats.product_id, props.seats.spot_id]);

  return (
    <CouponSelectSheet
      isOpen={props.visible}
      onClose={togModal}
      onApply={() => props.setVisible(false)}
      applyDisabled={!selectedCouponForSeat}
      loading={isLoading}
      isEmpty={isSuccess && !filteredCoupons.length}
      hasMore={hasNextPage}
      onLoadMore={() => fetchNextPage()}
    >
      {filteredCoupons.map((item: any, j: number) => (
        <CouponReservationItem
          key={item.id}
          item={item}
          index={j}
          pageIndex={0}
          seats={props.seats}
          selectCoupon={props.selectCoupon}
          toggleReservationDiscountCouponSelection={props.toggleReservationDiscountCouponSelection}
          boundType={boundType}
          holidays={holidays}
        />
      ))}
    </CouponSelectSheet>
  );
});

export default CouponReservationSelectModal;
